import styled from "styled-components";

import { setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export interface ICountdownTimerTheme {
    timeBoxWrapperBorderColor?: string;
    timeBoxWrapperBackground?: string;
    timeValueColor?: string;
    timeLabelColor?: string;
    withLabel?: boolean;
}

export const TimerContainer = styled(Flex)`
    justify-content: center;
    gap: 16px;
    padding: 9px 0 7px 0;
`;

export const TimeBoxWrapper = styled(Stack)<{ $theme: ICountdownTimerTheme }>`
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${({ $theme }) => $theme.timeBoxWrapperBorderColor};
    background: ${({ $theme }) => $theme.timeBoxWrapperBackground};
    backdrop-filter: blur(22px);
    width: 60px;
    height: 60px;
    flex-shrink: 0;
`;

export const TimeValue = styled.span<{ $theme: ICountdownTimerTheme }>`
    ${({ $theme }) => setFontVariant("h5", $theme.timeValueColor)};
    font-weight: bolder;
    align-items: center;
`;

export const TimeLabel = styled.span<{ $theme: ICountdownTimerTheme }>`
    ${({ $theme }) => setFontVariant("body2", $theme.timeLabelColor)};
`;
